import Button from 'components/Form/Button';
import UploadFileStage from 'components/Form/UploadFileStage';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { GET, POST, PUT, UploadImage } from 'services/api';
import { confirmDocumentation, sendDocumentation } from 'services/api-omni';
import { parseStrapiImage } from 'utils';
import Wrapper from '../Wrapper';
import {
  AddProposalContainer,
  AlertaPendencia,
  BotaoAnexar,
  BotaoDocumento,
  CompanyButtonContainer,
  ListaPendencia,
  RowContainer,
} from './styled';

export default function ConfirmDocumentation({ dados, reload }) {
  const { setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const [botLoading, setBotLoading] = useState(false);
  const [docsOk, setDocsOK] = useState(false);
  const [docIdent, setDocIdent] = useState(null);
  const [docRenda, setDocRenda] = useState(null);
  const [docSelfie, setDocSelfie] = useState(null);
  const isSignatureDisabled = !docIdent || !docSelfie || !docsOk;
  const close = () => {
    setModal(null);
    reload?.();
  };

  const init = useCallback(async () => {
    const result = await GET(`/clients/${dados.customerId}`, true);
    const foto = Array.isArray(result?.foto_cliente)
      ? result?.foto_cliente[0]
      : result?.foto_cliente;
    const identificacao = Array.isArray(result?.documento_identificacao)
      ? result?.documento_identificacao[0]
      : result?.documento_identificacao;
    const documentRenda = Array.isArray(result?.comprovante_renda)
      ? result?.comprovante_renda[0]
      : result?.comprovante_renda;
    if (identificacao) setDocIdent(identificacao);
    if (documentRenda) setDocRenda(documentRenda);
    if (foto) setDocSelfie(foto);
  }, [dados]);

  useEffect(() => {
    if (!dados) return;
    init();
  }, [dados, init]);

  const handleSolGetSelfie = async () => {
    try {
      setBotLoading(true);
      const vari = {
        id: dados.proposalId,
      };
      await POST('/webhook/selfiesol', vari, true);
      toast.success('A Sol irá realizar a solicitação da selfie do cliente.');
    } catch (err) {
      console.error(err);
      toast.error('Erro ao chamar a Sol para solicitar selfie.');
    } finally {
      setBotLoading(false);
    }
  };
  const save = async () => {
    if (!docIdent || !docSelfie) {
      toast.error('Documento de identificação e selfie são obrigatórios.');
      return;
    }
    try {
      setLoading(true);
      const [resFoto, resIdent, resRenda] = await Promise.all([
        docSelfie instanceof File
          ? UploadImage(docSelfie)
          : Promise.resolve(null),
        docIdent instanceof File
          ? UploadImage(docIdent)
          : Promise.resolve(null),
        docRenda instanceof File
          ? UploadImage(docRenda)
          : Promise.resolve(null),
      ]);
      const payload = {
        foto_cliente: resFoto ? resFoto[0].id : docSelfie?.id || null,
        documento_identificacao: resIdent
          ? resIdent[0].id
          : docIdent?.id || null,
        comprovante_renda: resRenda ? resRenda[0].id : docRenda?.id || null,
      };
      await PUT(`/clients/${dados.customerId}`, payload, true);
      toast.success('Registro salvo com sucesso!');
      close();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };
  const assinar = async () => {
    try {
      setLoading(true);
      const vari = {
        id: dados.proposalId,
      };
      // Chama endpoint que vai disparar a Sol
      await POST('/sol/assinatursol', vari, true);
      toast.success(
        'A Sol irá conversar com o cliente para inicar a assinatura.'
      );
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || 'Erro ao iniciar fase de assinatura'
      );
    } finally {
      setLoading(false);
    }
  };
  const confirmarDoc = async () => {
    try {
      setLoading(true);
      const payload = {
        omniId: dados.omniId,
        distribuidorId: dados.distribuidor,
      };
      const response = await confirmDocumentation(payload);
      if (response.status === 200) {
        setDocsOK(true);
        toast.success(response.message || 'Documentos validados com sucesso!');
      } else {
        toast.warning(
          response.message || 'Aguardando validação de documentos.'
        );
      }
    } catch (err) {
      console.error(err);
      const errorMessage =
        err?.response?.data?.message ||
        'Documentos obrigatórios pendentes na Omni.';
      const details = err?.response?.data?.details;
      const fullMessage = details
        ? `${errorMessage} (${details.join(', ')})`
        : errorMessage;
      toast.error(fullMessage);
    } finally {
      setLoading(false);
    }
  };
  const reenviarDocs = async () => {
    try {
      setLoading(true);
      const response = await sendDocumentation(dados.proposalId);
      if (response.status === 202) {
        toast.success(response.message || 'Documentos reenviados a Omni!');
      } else {
        toast.warning(
          response.message ||
            'Erro interno no agendamento do envio de documentos a Omni.'
        );
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || 'Erro ao reenviar documentos a Omni.'
      );
    } finally {
      setLoading(false);
    }
  };
  const urlParaAbrir = (document) =>
    document instanceof File
      ? URL.createObjectURL(document)
      : parseStrapiImage(document?.url);

  if (!dados) return null;

  return (
    <Wrapper title="Validar Documentação">
      <AddProposalContainer>
        <RowContainer>
          <BotaoDocumento
            hasFile={!!docSelfie}
            onClick={() =>
              docSelfie && window.open(urlParaAbrir(docSelfie), 'new')
            }
            style={{ cursor: docSelfie ? 'pointer' : 'default' }}
          >
            {docSelfie instanceof File ? (
              <span>
                <b>Selecionado:</b> {docSelfie.name}
              </span>
            ) : docSelfie ? (
              <span>✅ Selfie (OK)</span>
            ) : (
              'Solicite ou anexe a Foto de Identificação (Selfie)'
            )}
          </BotaoDocumento>
          <UploadFileStage
            onChange={(file) => setDocSelfie(file)}
            proposalType="A_Pagar"
          >
            <BotaoAnexar color="blue">Anexar</BotaoAnexar>
          </UploadFileStage>
        </RowContainer>
        <RowContainer>
          <BotaoDocumento
            hasFile={!!docIdent}
            onClick={() =>
              docIdent && window.open(urlParaAbrir(docIdent), 'new')
            }
            style={{ cursor: docIdent ? 'pointer' : 'none' }}
          >
            {docIdent instanceof File ? (
              <span>
                <b>Selecionado:</b> {docIdent.name}
              </span>
            ) : docIdent ? (
              <span>✅ Documento de Identificação (OK)</span>
            ) : (
              'Anexe o Documento de Identificação'
            )}
          </BotaoDocumento>
          <UploadFileStage
            onChange={(file) => setDocIdent(file)}
            proposalType="A_Pagar"
          >
            <BotaoAnexar color="blue">Anexar</BotaoAnexar>
          </UploadFileStage>
        </RowContainer>
        <RowContainer>
          <BotaoDocumento
            hasFile={!!docRenda}
            onClick={() =>
              docRenda && window.open(urlParaAbrir(docRenda), 'new')
            }
            style={{ cursor: docRenda ? 'pointer' : 'default' }}
          >
            {docRenda instanceof File ? (
              <span>
                <b>Selecionado:</b> {docRenda.name}
              </span>
            ) : docRenda ? (
              <span>✅ Comprovante de Renda (OK)</span>
            ) : (
              'Anexe o Comprovante de Renda'
            )}
          </BotaoDocumento>
          <UploadFileStage
            onChange={(file) => setDocRenda(file)}
            proposalType="A_Pagar"
          >
            <BotaoAnexar color="blue">Anexar</BotaoAnexar>
          </UploadFileStage>
        </RowContainer>
      </AddProposalContainer>
      <CompanyButtonContainer>
        <Button
          color="cian"
          disabled={docsOk}
          loading={loading}
          onClick={confirmarDoc}
          nospace
        >
          Confirmar Documentos
        </Button>
        <Button
          color="blue"
          disabled={docsOk}
          loading={loading}
          onClick={reenviarDocs}
          nospace
        >
          Reenviar Documentos
        </Button>
        <Button
          color="purple"
          disabled={docsOk}
          onClick={handleSolGetSelfie}
          loading={botLoading || loading}
        >
          Solicitar Selfie (SOL)
        </Button>
      </CompanyButtonContainer>
      {isSignatureDisabled && (
        <AlertaPendencia>
          <strong>Pendências para Assinatura:</strong>
          <ListaPendencia>
            {!docSelfie && <li>Anexar Selfie</li>}
            {!docIdent && <li>Anexar Documento de Identificação</li>}
            {!docsOk && (
              <li>Clicar em "Confirmar Documentos" para validar na Omni</li>
            )}
          </ListaPendencia>
        </AlertaPendencia>
      )}
      <CompanyButtonContainer>
        <Button color="lightgrey" onClick={close} border nospace>
          Cancelar
        </Button>
        <Button color="blue" loading={loading} onClick={save} nospace>
          Salvar
        </Button>
        <Button
          color="green"
          loading={loading}
          onClick={assinar}
          nospace
          disabled={isSignatureDisabled}
        >
          Assinar Contrato
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
}
